<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <div class="row">
        <div class="col-sm-6 leftcol">
          <h3>{{ _('Identification') }}</h3>
          <div class="form-group">
            <label for="name">{{ _('Name') }}</label>
            <input type="text" class="form-control" id="clientName" v-model="userinterface.name" :placeholder="_('Enter user interface name')" />
          </div>
          <div class="form-group">
            <label for="type">{{ _('Type') }}</label>
            <select class="form-control" v-model="userinterface.floating">
              <option value="0">{{ _('Fixed') }}</option>
              <option value="1">{{ _('Floating') }}</option>
            </select>
          </div>
          <div class="form-group" v-if="!parseInt(userinterface.floating)">
            <div class="checkbox">
              <label>
              <input type="checkbox" v-model="userinterface.selfservice" true-value="1" false-value="0" />
              {{ _('Self-service UI') }}
              </label>
            </div>
          </div>
          <div class="form-group" v-if="parseInt(userinterface.floating)">
            <div class="checkbox">
              <label>
              <input type="checkbox" v-model="userinterface.istemplate" true-value="1" false-value="0" />
              {{ _('Use this user interface as a template when creating new users') }}
              </label>
            </div>
          </div>
          <div class="form-group" v-if="parseInt(userinterface.floating) && linkedClients && linkedClients.length">
            <label>{{ _('Linked browsers') }}</label>
            <ul class="list-group">
              <li class="list-group-item" v-for="lc in linkedClients">
                <strong>{{ lc.browser.vendor }} {{ lc.browser.name }} ({{ lc.browser.category }})</strong><template v-if="lc.ip">, {{ lc.ip }}</template><span class="fa fa-fw fa-close pull-right" style="cursor: pointer" v-on:click="removeLinkedClient(lc)"></span><span class="pull-right" v-if="lc.date">{{ DateTime.fromISO(lc.date).toFormat(dateFormat) }} </span>
                <br /><small>{{ lc.user }}</small>
              </li>
            </ul>
          </div>
          <div class="form-group" v-else>
            <label for="identifier">{{ _('Identifier') }}</label>
            <input type="text" class="form-control" id="clientIdentifier" v-model="userinterface.identifier" :placeholder="_('Enter user interface identifier')" />
          </div>
          <div class="form-group">
            <label>{{ _('Point of use') }}</label>
            <select class="form-control" id="mainPos" :placeholder="_('Select a point of use')" v-model="selectedPos">
              <option v-for="pos in allPoses" :value="pos.id">{{ pos.name }}</option>
              <option value="new">{{ _('Create a new point of use') }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>{{ _('Default layout section') }}</label>
            <select class="form-control" id="mainLayout" :placeholder="_('Select the default layout section')" v-model="selectedLayout">
              <option v-for="layout in allLayouts" :value="layout.id">{{ layout.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>{{ _('Other layout sections') }}</label>
            <draggable-multi-selector v-if="userinterface && userinterface.sharedLayout" v-model="additionalLayouts" :items="allLayouts" itemProperty="name" :selectorTitle="_('Add layout sections')" :noItemsText="_('No other layout sections selected')" />
          </div>
          <div class="form-group">
            <label>{{ _('Floating receipt') }}</label>
            <select class="form-control" id="menuIcons" v-model="userinterface.floatingreceipt">
              <option v-for="receipt in receiptComponents" :value="receipt.id">{{ receipt.name }}</option>
              <option :value="null">{{ _('Do not use a floating receipt') }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>{{ _('Menu icons') }}</label>
            <select class="form-control" id="menuIcons" v-model.number="userinterface.hidemenuicons">
              <option :value="0">{{ _('Show icons') }}</option>
              <option :value="1">{{ _('Hide icons') }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="columnTabs">{{ _('Column tabs') }}</label>
            <select class="form-control" id="columnTabs" v-model="columnTabsMode">
              <option value="row">{{ _('One row with a More menu') }}</option>
              <option value="grid">{{ _('Button grid') }}</option>
              <option value="gridfixed">{{ _('Button grid, fixed columns') }}</option>
            </select>
          </div>
          <div class="form-group">
            <div class="checkbox">
              <label>
              <input type="checkbox" v-model="userinterface.gimmicks" true-value="1" false-value="0" />
              {{ _('Bling bling?') }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-sm-6 rightcol" id="bamboraCol">
          <h3>{{ _('Payment terminal') }}</h3>
          <div class="form-group">
            <label for="terminalId">{{ _('Terminal ID') }}</label>
            <input type="text" class="form-control" id="terminalId" v-model="userinterface.paymentterminal" :placeholder="_('Enter payment terminal ID')" />
          </div>
          <div class="form-group">
            <label for="contract">{{ _('Contract') }}</label>
            <select class="form-control" v-model="userinterface.contract">
              <option value="">{{ _('Not selected') }}</option>
              <option v-if="settings.pay_option19_merchantid" value="viva">{{ _('Viva') }} ({{ _('supports single merchant sales') }})</option>
              <option value="acceptance">{{ _('Worldline Acceptance') }} ({{ _('supports single merchant sales') }})</option>
              <option value="payform">{{ _('Visma Pay') }} ({{ _('supports shared shops') }})</option>
            </select>
          </div>
        </div>
        <div class="col-sm-6 rightcol" id="legacyCol">
          <h3>{{ _('External printers') }}</h3>
          <template v-for="device of editableExternalPrinters">
            <h4>{{ device.machine }}</h4>
            <div class="form-group" v-if="device.printers.length">
              <ul class="list-group">
                <li class="list-group-item" v-for="printer in device.printers" style="overflow-x: visible; cursor: pointer;" v-on:click.self="togglePrinterExpansion(printer)">
                  <strong v-on:click.self="togglePrinterExpansion(printer)">{{ printer.Name }}</strong>
                  <button v-if="!isPrinterExpanded(printer)" type="button" class="btn btn-default btn-xs" style="float: right; font-size: 8px;" v-on:click="togglePrinterExpansion(printer)"><i class="fa fa-fw fa-chevron-down"></i></button>
                  <select class="form-control" v-model="printer.Format" v-if="isPrinterExpanded(printer)" style="margin-top: 5px;">
                    <option :value="null">{{ _('No format selected') }}</option>
                    <option value="203dpi-72mm-std">80mm (72mm printable), 203 dpi</option>
                    <option value="203dpi-72mm-esc">80mm (72mm printable), 203 dpi, ESC/POS</option>
                    <option value="203dpi-72mm-rawescpos">80mm (72mm printable), 203 dpi, RAW ESC/POS</option>
                    <option value="203dpi-104mm-std">112mm (104mm printable), 203 dpi</option>
                    <option value="203dpi-104mm-esc">112mm (104mm printable), 203 dpi, ESC/POS</option>
                    <option value="203dpi-104mm-rawescpos">112mm (104mm printable), 203 dpi, RAW ESC/POS</option>
                    <option value="boca-raw">BOCA ticket printer, RAW</option>
                    <option value="300dpi-A4-std">A4, 300 dpi</option>
                  </select>
                  <div style="margin-top: 5px" v-if="isPrinterExpanded(printer)">
                    <button style="margin-bottom: 5px" v-on:click="togglePrinterType('Receipts', printer)" type="button" :class="'btn btn-xs ' + (printer.Types.includes('Receipts') ? ' btn-primary' : 'btn-default')"><i class="fa fa-fw fa-check" v-if="printer.Types && printer.Types.includes('Receipts')"></i> {{ _('Receipts') }}</button>
                    <button style="margin-bottom: 5px" v-on:click="togglePrinterType('Tickets', printer)" type="button" :class="'btn btn-xs ' + (printer.Types.includes('Tickets') ? ' btn-primary' : 'btn-default')"><i class="fa fa-fw fa-check" v-if="printer.Types && printer.Types.includes('Tickets')"></i> {{ _('Tickets') }}</button>
                    <button style="margin-bottom: 5px" v-on:click="togglePrinterType('Manifests', printer)" type="button" :class="'btn btn-xs ' + (printer.Types.includes('Manifests') ? ' btn-primary' : 'btn-default')"><i class="fa fa-fw fa-check" v-if="printer.Types && printer.Types.includes('Manifests')"></i> {{ _('Manifests') }}</button>
                    <button style="margin-bottom: 5px" v-on:click="togglePrinterPos(posId, printer)" type="button" class="btn btn-info btn-xs" v-for="posId in printer.PosIds">{{ getPosName(posId) }}</button>
                    <Dropdown buttonClass="btn-default btn-xs" menuClass="dropdown-menu-right" v-if="!printer.PosIds || (allPoses && allPoses.length > printer.PosIds.length)">
                      <template #trigger>
                        <i class="fa fa-fw fa-plus"></i>&nbsp;<span class="caret"></span>
                      </template>
                      <li v-for="pos in allPoses.filter(pos => !printer.PosIds.includes(pos.id))" v-on:click="togglePrinterPos(pos.id, printer)"><a href="javascript:;">{{ pos.name }}</a><i></i></li>
                    </Dropdown>
                  </div>
                </li>
              </ul>
            </div>
          </template>
          <div class="form-group">
            <h4>{{ _('Receipt printer') }}</h4>
            <label for="receiptPrinterFormat">{{ _('Format') }}</label>
            <select class="form-control" id="receiptPrinterFormat" v-model="userinterface.receiptprinter">
              <option value="">{{ _('No format selected') }}</option>
              <option value="203dpi-72mm">{{ _('80mm (72mm printable)') }}</option>
              <option value="203dpi-72mm-rawescpos">{{ _('80mm (72mm printable)') }} RAW ESC/POS</option>
              <option value="203dpi-72mm-rawescpos/nopagemode">{{ _('80mm (72mm printable)') }} RAW ESC/POS, Star TSP100</option>
              <option value="203dpi-104mm">{{ _('112mm (104mm printable)') }}</option>
              <option value="203dpi-104mm-rawescpos">{{ _('112mm (104mm printable)') }} RAW ESC/POS</option>
              <option value="203dpi-104mm-rawescpos/nopagemode">{{ _('112mm (104mm printable)') }} RAW ESC/POS, Star TSP100</option>
            </select>
          </div>
          <div class="form-group">
            <h4>{{ _('Ticket printer') }}</h4>
            <label for="ticketPrinterFormat">{{ _('Format') }}</label>
            <select class="form-control" id="ticketPrinterFormat" v-model="userinterface.ticketprinter">
              <option value="">{{ _('No format selected') }}</option>
              <option value="203dpi-72mm">{{ _('80mm (72mm printable)') }}</option>
              <option value="203dpi-72mm-rawescpos">{{ _('80mm (72mm printable)') }} RAW ESC/POS</option>
              <option value="203dpi-72mm-rawescpos/nopagemode">{{ _('80mm (72mm printable)') }} RAW ESC/POS, Star TSP100</option>
              <option value="203dpi-104mm">{{ _('112mm (104mm printable)') }}</option>
              <option value="203dpi-104mm-rawescpos">{{ _('112mm (104mm printable)') }} RAW ESC/POS</option>
              <option value="203dpi-104mm-rawescpos/nopagemode">{{ _('112mm (104mm printable)') }} RAW ESC/POS, Star TSP100</option>
              <option value="boca-raw">{{ _('BOCA ticket printer') }}</option>
            </select>
          </div>
          <div class="form-group" v-if="isFeatureEnabled('manifestprinter')">
            <h4>{{ _('Delivery manifest printer') }}</h4>
            <label for="manifestPrinterFormat">{{ _('Format') }}</label>
            <select class="form-control" id="manifestPrinterFormat" v-model="userinterface.manifestprinter">
              <option value="">{{ _('No format selected') }}</option>
              <option value="203dpi-72mm">{{ _('80mm (72mm printable)') }}</option>
              <option value="203dpi-72mm-rawescpos">{{ _('80mm (72mm printable)') }} RAW ESC/POS</option>
              <option value="203dpi-72mm-rawescpos/nopagemode">{{ _('80mm (72mm printable)') }} RAW ESC/POS, Star TSP100</option>
              <option value="203dpi-104mm">{{ _('112mm (104mm printable)') }}</option>
              <option value="203dpi-104mm-rawescpos">{{ _('112mm (104mm printable)') }} RAW ESC/POS</option>
              <option value="203dpi-104mm-rawescpos/nopagemode">{{ _('112mm (104mm printable)') }} RAW ESC/POS, Star TSP100</option>
              <option value="300dpi-A4">{{ _('A4') }}</option>
            </select>
          </div>
          <div class="well" v-if="userinterface.receiptprinter || userinterface.ticketprinter || userinterface.manifestprinter">
            <div class="row">
              <div class="col-sm-9">
                <p><i>{{ _('Note: Using external printers requires that you install Johku Printer on the PC that these printers are connected to.') }}</i></p>
              </div>
              <div class="col-sm-3">
                <a class="btn btn-info" href="https://johkuprinter.jalusta.com/" target="_blank"><i class="fa fa-fw fa-download"></i> {{ _('Download') }}</a>
              </div>
            </div>
          </div>
          <h3>{{ _('Settings') }}</h3>
          <div class="form-group">
            <label for="defaulttickettype">{{ _('Tickets') }}</label>
            <select class="form-control" v-model="userinterface.defaulttickettype">
              <option value="combined">{{ _('Print combined tickets') }}</option>
              <option value="separate">{{ _('Print separate tickets') }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="printjobs">{{ _('Print jobs') }}</label>
            <select class="form-control" v-model="userinterface.printjobs">
              <option value="combined">{{ _('Combine print jobs into one') }}</option>
              <option value="separate">{{ _('Print everything as separate print jobs') }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="printingthickness">{{ _('Printing thickness') }}</label>
            <select class="form-control" v-model="userinterface.printingthickness">
              <option value="normal">{{ _('Default') }}</option>
              <option value="bold">{{ _('Bold') }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="deliveries">{{ _('Default delivery method') }}</label>
            <select class="form-control" v-model="userinterface.defaultdelivery">
              <option :value="null">{{ _('Not set') }}</option>
              <option v-for="dm in deliveryMethods" :value="dm.id">{{ dm.name }}</option>
            </select>
          </div>
          <h3>{{ _('Gas Pump') }}</h3>
          <div class="form-group">
            <div class="checkbox">
              <label>
              <input type="checkbox" v-model="userinterface.primarygaspump" true-value="1" false-value="0" />
              {{ _('Primary') }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <nav class="save-bar">
      <div class="flex-row space-between">
        <div class="button-col">
          <button v-if="isDeleteButtonAvailable" class="btn btn-danger" type="button" v-on:click="remove"><i class="fa fa-fw fa-trash"></i><span class="hidden-xs"> {{ _('Delete') }}</span></button>
          <button class="btn btn-default" v-on:click="copyDialog" type="button"><i class="fa fa-fw fa-copy"></i> {{ _('Copy') }}</button>
        </div>
        <div class="to-right">
          <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i><span class="hidden-xs"> {{ _('Close') }}</span></button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import settingshelpers from '~/lib/settingshelpers'
import { DraggableMultiSelector } from '#components'
import { mapGetters } from 'vuex'
import { normalizeColumnTabsMode } from '~/composables/useTabGrid'
import { DateTime } from 'luxon'
import * as woothee from 'woothee'

export default {
  data () {
    return {
      userinterface: {},
      allLayouts: [],
      allPoses: [],
      receiptComponents: [],
      makeNewPos: false,
      deliveryMethods: [],
      externalPrinters: {},
      editableExternalPrinters: {},
      DateTime: DateTime
    }
  },
  mixins: [components, settingshelpers],
  computed: {
    ...mapGetters(['clientIdNumber']),
    // JDEV-3370: how the column headers show their tabs; empty (NULL, or an older backend) is the one row.
    columnTabsMode: {
      get () {
        return normalizeColumnTabsMode(this.userinterface.columntabs)
      },
      set (value) {
        this.userinterface.columntabs = value
      }
    },
    selectedPos: {
      get () {
        if (this.makeNewPos) {
          return 'new'
        }
        return this.userinterface.sharedPos && this.userinterface.sharedPos[0] ? this.userinterface.sharedPos[0].id : null
      },
      set (newValue) {
        if (newValue === 'new') {
          this.makeNewPos = true
        } else {
          this.makeNewPos = false
          this.userinterface.sharedPos = [this.allPoses.find(p => parseInt(p.id, 10) === parseInt(newValue, 10))]
        }
      }
    },
    selectedLayout: {
      get () {
        return this.userinterface.sharedLayout && this.userinterface.sharedLayout[0] ? this.userinterface.sharedLayout[0].id : null
      },
      set (newValue) {
        this.userinterface.sharedLayout[0] = this.allLayouts.find(l => parseInt(l.id, 10) === parseInt(newValue, 10))
      }
    },
    additionalLayouts: {
      get () {
        return this.userinterface && this.userinterface.sharedLayout && this.userinterface.sharedLayout.length > 1 ? this.userinterface.sharedLayout.slice(1) : []
      },
      set (newValue) {
        this.userinterface.sharedLayout = [this.userinterface.sharedLayout[0], ...newValue]
      }
    },
    linkedClients () {
      if (!this.userinterface || !this.userinterface.ownLinkedclient || !this.userinterface.ownLinkedclient.length) {
        return []
      }
      return this.userinterface.ownLinkedclient.map(o => ({ ...o, browser: woothee.parse(o.ua) }))
    },
    isDeleteButtonAvailable () {
      return this.userinterface && this.userinterface.id && (parseInt(this.clientIdNumber, 10) !== parseInt(this.userinterface.id, 10))
    }
  },
  methods: {
    removeLinkedClient(linkedClient) {
      this.userinterface.ownLinkedclient = this.userinterface.ownLinkedclient.filter(lc => lc.id !== linkedClient.id)
    },
    copyDialog () {
      this.showDialog({
        title: this._('Enter a name for the new user interface'),
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            requiredFields: ['name'],
            handler: (data) => {
              this.copy(data.name)
            }
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name',
            placeholder: this._('Enter a name for the new user interface')
          }
        ]
      })
    },
    async copy (name) {
      let response
      const data = {
        name
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/clients/' + this.userinterface.id + '/copy.json?apikey=' + this.apiKey, data)
      } catch(e) {
        return this.showError(this._('Copying failed!'))
      }
      this.showNotification(this._('User interface copied.'))
    },
    getSaveData () {
      const exportFields = [
        'id',
        'name',
        'floating',
        'selfservice',
        'identifier',
        'defaulttickettype',
        'printjobs',
        'printingthickness',
        'paymentterminal',
        'contract',
        'receiptprinter',
        'ticketprinter',
        'manifestprinter',
        'hidemenuicons',
        'columntabs',
        'floatingreceipt',
        'istemplate',
        'gimmicks',
        'primarygaspump',
        'defaultdelivery',
        'ownLinkedclient'
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.userinterface[e], a), {})
      if (this.makeNewPos) {
        data.pos = 'new'
      } else {
        data.pos = this.userinterface.sharedPos && this.userinterface.sharedPos[0] ? this.userinterface.sharedPos[0].id : null
      }
      if (!parseInt(data.floating)) {
        data.istemplate = '0'
      } else {
        data.selfservice = '0'
      }
      data.layout = this.userinterface.sharedLayout && this.userinterface.sharedLayout[0] ? this.userinterface.sharedLayout[0].id : null
      data.layouts = this.userinterface.sharedLayout.map(l => l.id).join(';')
      return data
    },
    async doRemove () {
      let response
      try {
        response = await axios.delete(this.baseDomain + this.shopId + '/clients/' + this.userinterface.id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        return this.showError(e)
      }
      this.close()
    },
    async save () {
      this.saving = true
      const data = this.getSaveData()

      // Viva terminals are identified by contract, not by Visma Pay credentials.
      const isVivaTerminal = (data.contract || '') === 'viva'
      if (data.paymentterminal && data.paymentterminal.toLowerCase() != 'external' && !isVivaTerminal) {
        if (!this.settings.pay_option9_privatekey || !this.settings.pay_option9_apikey) {
          this.saving = false
          return this.showError(this._('Payment terminal ID is defined, but visma pay settings are not configured.'))
        }
      }
      if (Object.keys(this.editableExternalPrinters).length) {
        this.saveExternalPrinters()
      }

      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/clients/' + data.id + '.json?apikey=' + this.apiKey, data)
        } else {
          delete data.id
          response = await axios.post(this.baseDomain + this.shopId + '/clients.json?apikey=' + this.apiKey, data)
        }
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      if (response && response.data && response.data.id) {
        await this.loadUserinterface(response.data.id)
      }
      this.saving = false
      this.saved = true
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.resource)
      if (this.saveShouldClose) {
        this.close()
      }
    },
    loadUserinterface (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/clients/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        this.userinterface = response.data
        this.storeState()
        this.loading = false
        resolve(this.layout)
      })
    },
    async loadLayouts () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/layouts.json?iSortingCols=1&iSortCol_0=1&sSortDir=asc&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      this.allLayouts = response.data
    },
    async loadPoses () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/pos.json?iSortingCols=1&iSortCol_0=1&sSortDir=asc&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      this.allPoses = response.data
    },
    async loadReceiptComponents () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/components.json?iSortingCols=1&iSortCol_0=1&sSortDir=asc&sSearch_2=Receipt&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      this.receiptComponents = response.data
    },
    loadDeliverymethods () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/deliverymethods.json?tags=true&shipitmethods=true&apikey=' + this.apiKey)
        } catch(e) {
          this.showError(e)
          reject()
          return
        }
        this.deliveryMethods = response.data
        resolve(this.deliveryMethods)
      })
    },
    queryExternalPrinters () {
      this.EventBus.$emit('requestPrinters', {})
    },
    getPosName(posId) {
      return this.allPoses.find(p => Number(p.id) === Number(posId))?.name || posId
    },
    togglePrinterType(printerType, printer) {
      if (printer.Types.includes(printerType)) {
        printer.Types = printer.Types.filter(t => t !== printerType)
      } else {
        printer.Types.push(printerType)
      }
    },
    togglePrinterPos(posId, printer) {
      if (printer.PosIds.includes(posId)) {
        printer.PosIds = printer.PosIds.filter(p => p !== posId)
      } else {
        printer.PosIds.push(posId)
      }
    },
    setPrinterFormat(format, printer) {
      printer.Format = format
    },
    isPrinterExpanded(printer) {
      return printer.Expanded || printer.Types.length > 0 || printer.PosIds.length > 0 || !!printer.Format
    },
    togglePrinterExpansion(printer) {
      printer.Expanded = !printer.Expanded
    },
    saveExternalPrinters() {
      for (const device of Object.values(this.editableExternalPrinters)) {
        if (device.printers) {
          device.printers.forEach(p => {
            const ep = this.externalPrinters[device.deviceId]
            if (ep && ep.printers && ep.printers.length) {
              const cp = ep.printers.find(ep => ep.Name === p.Name)
              const currConfig = {
                deviceId: device.deviceId,
                name: cp.Name,
                format: cp.Format,
                types: cp.Types,
                ids: cp.PosIds.map(Number)
              }
              const newConfig = {
                deviceId: device.deviceId,
                name: p.Name,
                format: p.Format,
                types: p.Types,
                ids: p.PosIds.map(Number)
              }
              if (JSON.stringify(currConfig) !== JSON.stringify(newConfig)) {
                this.EventBus.$emit('setPrinterProperties', newConfig)
              }
            }
          })
        }
      }
    }
  },
  components: {
    DraggableMultiSelector
  },
  created () {
    if (this.component && this.component.initData) {
      this.loadUserinterface(this.component.initData.userinterfaceId)
    }
  },
  async mounted () {
    this.loadPoses()
    this.loadLayouts()
    this.loadReceiptComponents()
    this.loadDeliverymethods()
    this.queryExternalPrinters()
    if(!this.events) {
      let events = {}
      events['userinterfaceUpdate'] = async (message) => {
        if (message && message.data && this.userinterface && parseInt(message.data.id, 10) === parseInt(this.userinterface.id, 10)) {
          if (!this.unsavedChanges) { // Only update if we haven't made any changes
            this.loadUserinterface(message.data.id)
          }
        }
      }
      events['printers'] = async (message) => {
        if (message && message.data && message.data.printers && this.userinterface) {
          this.externalPrinters[message.data.deviceId] = message.data
          if (!this.editableExternalPrinters[message.data.deviceId] || !this.editableExternalPrinters[message.data.deviceId].length) {
            this.editableExternalPrinters[message.data.deviceId] = JSON.parse(JSON.stringify(message.data))
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (this.userinterface && this.userinterface.id && parseInt(this.userinterface.id, 10) !== parseInt(this.component.initData.userinterfaceId, 10)) {
        try {
          await this.loadUserinterface(this.component.initData.userinterfaceId)
        } catch(e) {}
      }
    }
  }
}
</script>